export const createValueAddsObj = (valueAddArray) => {
  let valueAddsObj = valueAddArray.map((value) => ({
    description: value,
    name: 'value adds',
    code: 'welcome_gift',
    icon: 'welcomeGift',
  }));
  return valueAddsObj;
};
